import { InputOptionMaster } from "App/Component/ui";
import { TYPE_INSTANCE1 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { isNull } from "App/utils/helpers";
import React from "react";

function PilihDokter({ formData, setFormData }) {
  const dokter = useSelectOption(
    true,
    "/doctor/listdoctor_regrj",
    TYPE_INSTANCE1,
    "id",
    "fullname"
  );

  return (
    <>
      <InputOptionMaster
        name='doctor_id'
        label='DOKTER'
        id='doctor_id'
        withSearch={true}
        data={dokter}
        value={formData.doctor_id}
        labelValue={formData.doctor_name}
        onChange={(e) => {
          if (isNull(e)) {
            setFormData({
              ...formData,
              doctor_id: null,
              doctor_name: "Pilih Dokter",
            });
          } else {
            setFormData({
              ...formData,
              doctor_id: e.value,
              doctor_name: e.label,
            });
          }
        }}
      />
    </>
  );
}

export default PilihDokter;
